import { FullScreenLoaderService } from './core/services/FullScreenLoader/full-screen-loader.service';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-bitwise */
import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Injector } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { environment as env, environment } from '../environments/environment';
import { LocalStorageService } from './core/services/localstorage.service';
import { getMessaging, onMessage, isSupported } from 'firebase/messaging';
import { UtilityService } from './core/services/utility_functions/utility_functions.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { Router, Event, NavigationEnd } from '@angular/router';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { LogoutAlertComponent } from './components/logout-alert/logout-alert.component';
import { FirebaseService } from './core/services/firebase/firebase.service';
import { MessagesService } from './layout/common/messages/messages.service';
import lgVideo from 'lightgallery/plugins/video';
import { LightGallery } from 'lightgallery/lightgallery';
import { AfterAppendSubHtmlDetail } from 'lightgallery/lg-events';
import { LightGalleryService } from './core/services/light-gallery.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './core/auth/auth.service';
import { ZuperSdkService } from './core/services/sdk_service/sdk.services';
import { UserService } from './core/user/user.service';
import { startTestBox} from "@testboxlab/browser";
import { NavigateEvent } from '@testboxlab/browser/lib/messaging/incoming';
import { ConversationMessageService } from '../../projects/zuper-connect/src/app/components/services/conversation-message.service';
import { ChatClientService } from 'stream-chat-angular';
import { ToastService } from '@app/core/services/toast/toast.service';
import { initCustomToFixed } from './core/services/utility_functions/number-utility';

initializeApp(env.firebase);
@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy
{
    title = 'TestComponent';
    message: any = null;
    showToast = false;
    lightGallery: LightGallery;
    settings = {
      counter: true,
      dynamic: true,
      licenseKey: env.lightGalleryKey,
      dynamicEl: [],
      loop: false,
      videojs: true,
      hideControlOnEnd: true,
      slideEndAnimation: false,
      appendSubHtmlTo: '.lg-outer',
      download: false,
      plugins: [lgVideo]
  };
  sdkIframeUrl: any;
  showFullScreenLoader: boolean;
  isUserLoggedIn: boolean;
  private _sdk: ZuperSdkService;
  private _sdkFrame: ElementRef<HTMLIFrameElement>;
  private _conversationMessageService: ConversationMessageService;

  // Stream Chat properties
  private isStreamChatEnabled: boolean = false;
  private currentUserId: string = '';
  private streamChatEventHandlers: Array<{ eventName: string; unsubscribe: () => void }> = [];

  @ViewChild('sdkFrame')
  set sdkFrame(frame: ElementRef<HTMLIFrameElement>) {
    if (frame) {
      if (!this._sdk) {
        this._sdk = this.injector.get(ZuperSdkService);
      }
      this._sdkFrame = frame;
      const childWindow = this._sdkFrame?.nativeElement.contentWindow;
      this._sdkFrame.nativeElement.onload = ((): void => {
        const iframeDoc = this._sdkFrame?.nativeElement.contentWindow.document;
        const iframeBody = iframeDoc.body;
        const sdkScript = iframeDoc.createElement('script');
        sdkScript.src = env.production ? 'https://cdn.zuper.dev/sdk/latest/zdk.min.js' : '../zdk/zsdk.min.js';
        iframeBody.appendChild(sdkScript);
        sdkScript.onload = ((): void => {
          const customScript = iframeDoc.createElement('script');
          const srcLink = this._sdk.fetchCustomSDKScript();
          if(srcLink){
            customScript.src = srcLink;
          }else{
            console.warn('Zuper UI SDK: Company ID or auth token not found in local storage to fetch custom script.');
          }
          iframeBody.appendChild(customScript);
          if (this._sdk) {
            this._sdk.connect(childWindow);
          }
        });
      });
    }
  }
    /**
     * Constructor
     */
    constructor(
        private _localStorageService: LocalStorageService,
        private _utilityService: UtilityService,
        private _notificationService: NotificationsService,
        private _messagingService: MessagesService,
        private _router: Router,
        public dialog: ZuperDialogService,
        private _firebaseService: FirebaseService,
        public _lightGalleryService: LightGalleryService,
        private _sanitizer: DomSanitizer,
        private _authService: AuthService,
        private _userService: UserService,
        private _fullScreenLoader: FullScreenLoaderService,
        private injector: Injector,
        private _chatClientService: ChatClientService,
        private _toastService: ToastService
        )
    {
      this.initializeTestBox();
      // Initialize custom toFixed method globally
      initCustomToFixed();
    }

    lightOnInit = (detail: any): void => {
      this.lightGallery = detail.instance;
      this._lightGalleryService.lightGallery = this.lightGallery;
    };

    lgAppendSubHTML = (detail: AfterAppendSubHtmlDetail): void => {
       this._lightGalleryService.getDownloadUrl(detail);
    };

    listen(): void{
      const messaging = getMessaging();
      onMessage(messaging, (payload)=>{
        let additionalData: any = {};
        if(payload && payload.data && payload.data.additional_data) {
          additionalData = JSON.parse(payload.data.additional_data);
        }
        this.message = payload;
        
        // Check if the action type is 'incomingMessage' and the message type is either 'SMS', 'MMS', or 'SYSTEM'
        // or if the message type is 'CALL' and the call status is either 'MISSED' or 'voicemail'
        if (additionalData.action_type === 'incomingMessage' && ['SMS', 'MMS', 'SYSTEM'].includes(additionalData?.messageType) || 
        (additionalData?.messageType === 'CALL' && ['MISSED', 'voicemail'].includes(additionalData.call?.status))) {
          this._conversationMessageService = this.injector.get(ConversationMessageService);
          this._conversationMessageService.getZuperConnectUnreadCountMessages();
        }
        else {
          // Update the message using the messaging service
          this._messagingService.updateMessage.next(payload);
        }

        this._messagingService.updateMessage.next(payload);
        this.sendNotification(payload, additionalData);
      });
    }

    sendNotification(payload: any, additionalData: any): void {


      if(additionalData && additionalData.action_type === 'USER' && additionalData.type === 'ACCESS_ROLE_UPDATE') {
        return;
      }
      if(Notification) {
        // PLAY SOUND
        const myAudio = new Audio('https://staging.zuperpro.com/assets/sound/push_notification.wav');
        myAudio.play().catch((error) => {
          console.error('Error playing sound:', error);
        });
        // END OF PLAY SOUND
        // RELOAD NOTIFICATIONS
        this._notificationService.getAllNotificationCount();
        // END RELOAD NOTIFICATION
      }


      //For multiple tabs
      if(document.hidden === true) {
        // Restrict notification if messageType is 'CALL'
        if (additionalData?.messageType !== 'CALL') {
          // TODO : redirectpage
          const n = new Notification(payload.data.title, {
            icon: 'https://staging.zuperpro.com/assets/images/favicon/apple-touch-icon.png',
            body: payload.data.body,
            tag : additionalData.redirect_to // TODO : include notification_uid here instead of redirect_to
          });
          n.onclick = (): void => {
            this.redirectPage(payload);
          };
        }
      }else{
        if(additionalData?.action_type === 'CHAT' && ('/chats/'+additionalData?.redirect_to) !== this._router.url){
          if(!this.showToast){
            this.showToast = true;
          }
          setTimeout(()=>{
            this.showToast = false;
          },500);
        }else if(additionalData?.action_type !== 'CHAT'){

          if(additionalData?.type === 'DEACTIVATE'){
            this._localStorageService.removeLocalStorage('push_token');
            this.dialog.openCustom( LogoutAlertComponent,{
              extraClass: 'logout-warning'
            });
            return;
          }
          if(!this.showToast){
            this.showToast = true;
          }
          setTimeout(()=>{
            this.showToast = false;
          },500);
        }
      }
    }

    redirectPage(payload): void {
      let url;
      let additionalData: any = {};
      if(payload && payload.data && payload.data.additional_data) {
        additionalData = JSON.parse(payload.data.additional_data.toString());
      }
      switch(payload.data.type) {
        case 'JOB':
          if(this._utilityService.hasModuleAccess('JOB')){
            url = '/jobs/' + payload.data.action_uid + '/details';
            if(additionalData.action_type === 'CHAT'){
              url += '?redirect_tab='+additionalData['action_type'];
              // if(window.reloadRecentMessage) { window.reloadRecentMessage() }
            }
            if(additionalData.type === 'NOTE'){
              url += '?redirect_tab=NOTES';
            }
          }
          break;
        case 'USER':
            if(additionalData && additionalData?.type === 'DELETE') {
              // $('#AccountDeletedModal').modal('show');
              setTimeout(()=> {
                window.localStorage.clear();
                window.location.href = '/login';
              }, 5000);
            }
            else if(additionalData && additionalData.type === 'DEACTIVATE') {
              // $('#AccountDeactivatedModal').modal('show');
              setTimeout(() => {
                window.localStorage.clear();
                window.location.href = '/login';
              }, 5000);
            }
            else if(this._utilityService.hasModuleAccess('USER')) {
              url = '/employees/' + payload.data.action_uid + '/details';
            }
          break;
        case 'TIMEOFF_REQUEST':
          if(this._utilityService.hasModuleAccess('TIMESHEET')){
            url = '/timesheets/timeoff_requests';
          }
          break;
        case 'BROADCAST':
          url = '/dashboard';
          break;
        case 'CALLER':
          if(additionalData?.conversation?.conversation_uid) {
            url = '/connect/conversations/' + additionalData.conversation.conversation_uid;
          }
          break;
        // case 'TODO':
      }
      window.focus();
      if(url) {
        window.location.href = url;
      }
    }

      ngOnInit(): void {
        window['mapTileUrl'] = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?lang=en&apiKey=${env.hereMapKey}`;
        isSupported().then((value: boolean)=>{
          this._firebaseService.requestPermission();
          this.listen();
        });

        if (this._authService.isAuthenticated()) {
          this.setIFrameURL();
          this.isUserLoggedIn = true;
        } else {
          this._userService.user$.subscribe((user: any) => {
            if (user?.user_uid?.length > 0) {
              this.setIFrameURL();
              this.isUserLoggedIn = true;
            }
          });
        }
        this._userService.logout$.subscribe((isLoggedOut: boolean)=>{
          if(isLoggedOut){
            this._sdk.reset();
            this.sdkIframeUrl = null;
            this.isUserLoggedIn= false;
          };
        });
        this._fullScreenLoader.fullScreenLoaderStatus.subscribe((canShowLoader: boolean)=> {
          this.showFullScreenLoader = canShowLoader;
        });
      }

    setIFrameURL(): void {
      const origin = window.origin;
      const companyInfo = this._localStorageService.getLocalStorage('company');
      if (companyInfo) {
        const appGuid = companyInfo.company_uid;
        const authToken = this._localStorageService.getLocalStorage('auth_token');
        const pathToHtmlFile = `./assets/html/sdk.html?origin=${origin}&app_guid=${appGuid}&authtoken=${authToken}`;
        this.sdkIframeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(pathToHtmlFile);
      }
    }
    
    initializeTestBox(): void {
      if (environment.production) {
        const navigateHandler = async (event: NavigateEvent) => {
          window.location.href = event.url;
        }
        startTestBox({
          allowFullStory: true,
          navigateHandler: navigateHandler,
        });
      }
    }

    /**
     * Check if Stream Chat is enabled and initialize
     */
    public checkAndInitializeStreamChat(): void {
      const companyPolicy = this._localStorageService.getLocalStorage('company_policy');
      this.isStreamChatEnabled = companyPolicy?.stream_chat?.is_enabled === true;

      if (!this.isStreamChatEnabled) {
        return;
      }

      // Get current user ID
      const user = this._localStorageService.getLocalStorage('user');
      if (user?.user_uid) {
        this.currentUserId = user.user_uid;
      }

      // Initialize Stream Chat event listeners
      this.listenToStreamChatMessages();
    }

    /**
     * Listen to Stream Chat message events
     */
    private listenToStreamChatMessages(): void {
      // Wait for chat client to be initialized
      if (!this._chatClientService.chatClient) {
        console.warn('Stream Chat client not initialized yet');
        return;
      }

      // Listen for new messages
      const messageNewHandler = this._chatClientService.chatClient.on('message.new', (event) => {
        // Check if message exists
        if (!event.message || !event.channel_id || !event.channel_type) {
          return;
        }

        // Condition 1: Exclude messages sent by current user
        if (event.message.user?.id === `user-${this.currentUserId}`) {
          return;
        }
        
        // Condition 2: Check if user is currently viewing this channel
        const currentUrl = this._router.url;
        const channelUrl = `/chats/${event.channel_type}/${event.channel_id}`;

        if (currentUrl === channelUrl) {
          return;
        }

        // Show toast notification
        if(!event?.message?.silent){
          this.showStreamChatToast(event);
        }
      });

      // Store handler for cleanup
      this.streamChatEventHandlers.push({
        eventName: 'message.new',
        unsubscribe: messageNewHandler.unsubscribe
      });
    }

    /**
     * Show Stream Chat toast notification
     */
    private async showStreamChatToast(event: any): Promise<void> {
      const channel = await this._chatClientService.chatClient.getChannelById(event?.channel_type, event?.channel_id, {});
      const message = event.message;

      // Get channel/sender name
      const senderName = message.user?.name || 'Unknown User';
      const channelName = this.getStreamChannelName(channel, senderName);

      // Get sender profile picture
      const senderProfilePic = message.user?.image || 'https://s3.ap-south-1.amazonaws.com/prod.app.zuperpro/assets/profile_picture.jpg';

      // Parse HTML to plain text for notification
      const parser = new DOMParser();
      const doc = parser.parseFromString(message.html || 'New message', 'text/html');
      const plainTextBody = doc.body.textContent || 'New message';

      // Create payload in Firebase format
      const payload = {
        data: {
          title: channelName,
          body: plainTextBody,
          type: 'STREAM_CHAT',
          additional_data: JSON.stringify({
            action_type: 'STREAM_CHAT',
            channel_type: event.channel_type,
            channel_id: event.channel_id,
            parent_id: message?.parent_id,
            sender_name: senderName,
            sender_profile_pic: senderProfilePic,
            message_id: message.id,
            message: message,
            redirect_to: `${event.channel_type}/${event.channel_id}`
          })
        }
      };

      // Use existing ToastService to show notification
      this._toastService.show(payload);

      // Play notification sound (reusing existing logic)
      const myAudio = new Audio('https://staging.zuperpro.com/assets/sound/push_notification.wav');
      myAudio.play().catch((error) => {
        console.error('Error playing sound:', error);
      });

      if(document.hidden === true) {
        // Restrict notification if messageType is 'CALL'
          // TODO : redirectpage
          const n = new Notification(payload.data.title, {
            icon: 'https://staging.zuperpro.com/assets/images/favicon/apple-touch-icon.png',
            body: payload.data.body,
            tag : `${event.channel_type}/${event.channel_id}`
          });
          n.onclick = (): void => {
            this.redirectPage(payload);
          };
        }
      
    }

    /**
     * Get Stream Chat channel name based on channel type
     */
    private getStreamChannelName(channel: any, senderName: string): string {
      if (channel.type === 'team') {
        // For team/group channels, return channel name
        return channel.data?.name || 'Channel Message';
      } else if (channel.type === 'messaging') {
        // For DMs, return sender name
        return senderName || 'Direct Message';
      }
      return 'New Message';
    }

    /**
     * On destroy - cleanup Stream Chat event listeners
     */
    ngOnDestroy(): void {
      // Cleanup Stream Chat event listeners
      if (this.streamChatEventHandlers.length > 0) {
        this.streamChatEventHandlers.forEach(handler => {
          if (handler.unsubscribe) {
            handler.unsubscribe();
          }
        });
      }
    }

}
